<template>
<div ref="SheduleEdit">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">编辑日程提醒</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="schedulelist.length > 1 ? schedulelist.length : ''" class="item">
        <el-button @click="submitData">提交数据</el-button>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="GoBackPets(false)">返回日程提醒</el-button>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in schedulelist" :key="index">
            <div class="TTL-form-submit-box-title">日程提醒-{{index+1}}</div>
            <div class="TTL-button TTL-btn-option">
            </div>
            <el-form :inline="false">
                <el-form-item>
                    <label class="TTL-form-label">选择宠物<i>*</i></label>
                    <div class="TTL-input TTL-form-input">
                        <el-select v-model="item.petid" placeholder="请选择宠物" filterable remote clearable @change='[changepet(index,item.petid),SaveDataToBrowser]'>
                            <el-option v-for="(t,i) in petlist" :key="i" :label="t.name" :value="t.id" />
                        </el-select>
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">选择提醒类型<i>*</i></label>
                    <div class="TTL-select">
                    <el-select v-model="item.notice_typeid" placeholder="请选择提醒类型"  clearable filterable @change="[Gettypeinfo(index),SaveDataToBrowser]">
                    <el-option v-for="(item,index) in typelist" :key="index" :label="item.name" :value="item.id" />
                    </el-select>
                    </div>
                    <div class="TTL-remind-image">
                        <el-image :src="item.notice_thumb ? item.notice_thumb : require('@/assets/icon/pet-upload-default.png')" />
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">创建日程日期<i>*</i></label>
                    <div class="TTL-datetime">
                    <el-date-picker v-model="item.create_day" type="date" value-format="YYYY-MM-DD" placeholder="请选择创建日程日期" @change="SaveDataToBrowser"/>
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">创建日程时间<i>*</i></label>
                    <div class="TTL-datetime">
                    <el-time-picker v-model="item.create_time" placeholder="请选择创建日程时间" format="HH:mm" value-format="HH:mm" @change="SaveDataToBrowser"/>
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">是否添加提醒信息</label>
                    <div class="TTL-switch">
                    <el-switch v-model="item.isremind" @change="SaveDataToBrowser"/>
                    </div>
                </el-form-item>
                <el-form-item v-if="item.isremind">
                    <label class="TTL-form-label">选择提醒日程日期<i>*</i></label>
                    <div class="TTL-datetime">
                    <el-date-picker v-model="item.remind_day" type="date" value-format="YYYY-MM-DD" placeholder="请选择提醒日期" @change="SaveDataToBrowser"/>
                    </div>
                </el-form-item>
                <el-form-item v-if="item.isremind">
                    <label class="TTL-form-label">选择提醒日程时间<i>*</i></label>
                    <div class="TTL-datetime">
                    <el-time-picker v-model="item.remind_time" placeholder="请选择提醒时间" format="HH:mm" value-format="HH:mm" @change="SaveDataToBrowser"/>
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">备注</label>
                    <div class="TTL-input">
                    <el-input type="textarea" v-model="item.note" class="width350" :autosize="{ minRows: 6, maxRows: 8}" @change="SaveDataToBrowser"/>
                    </div>
                </el-form-item>
                
            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import INTERFACE_MODEL_PETS from '@/Interface/Pets/Schedule';
import INTERFACE_MODEL_BASE from '@/Interface/index';
export default {
    components:{},
    data() {
        return {
            type:'add',
            file:'',             //图片变量，占位符
            addlimit: 10,        //单次新增限制
            schedulelist:[       //日程信息列表
                {petid:'',petname:'',notice_typeid:'',notice_typename:'',notice_thumb:'',create_day:'',create_time:[],isremind:false,remind_day:'',remind_time:'',note:'',}
            ],     
            typelist:[],         //提醒类型信息表
            petlist:[],          //宠物信息列表
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 修改页面显示标签信息 **/
        ChangePageLabel() {
            
        },


        /** 页数初始化 **/
        OnloadMethod() {
            this.GetSheduleTypeInfos();  //获取提醒信息类型
            this.GetPetList();           //获取宠物信息列表
            this.ParseDataFromBrowser(); //解析之前填写的数据
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //兄弟组件跳转至当前组件时进行询问操作
                this.$confirm.confirm('当前有数据正在执行编辑操作，是否要执行覆盖操作 ？','操作提示',{confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}).then(()=> {
                    this.GetScheduleInfos(data.ids); //获取待处理宠物
                }).catch(()=> {
                    
                });
            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                
            }else {
                this.GetScheduleInfos(data.ids); //获取待处理宠物
            }
        },


        /** 提交数据 **/
        submitData() {
            var checkresult=this.CheckDataBeforeSubmit();
            if(checkresult.error==1) {this.$notice({title:'提交数据提示',message:checkresult.message,type:'warning'});return false;}

            //调整提交数据
            var data=[];
            for(var i=0;i<this.schedulelist.length;i++) data.push(this.schedulelist[i]);
            data=JSON.stringify(data);

            var loadingobj=this.$refs.SheduleEdit;
            this.$loading.openloading(loadingobj);  //加载等待动画
            INTERFACE_MODEL_PETS.EDIT_SHEDULE({data:data}).then((res) => {
                this.$loading.closeloading(loadingobj);
                if(res.status > 0) return false;
                this.resetParam(); //重置当前数据
                this.$notice({title:'成功提示',message:'数据提交成功',type:'success'});
                this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
                this.GoBackPets(true);
            });
        },


        /** 数据提交前进行检测 **/
        CheckDataBeforeSubmit() {
            var result={error:0,message:''};
            if(this.schedulelist.length==0) {result={error:1,message:'请添加日程提醒信息'};return result;}

            //检测品种参数
            var obj;
            for(var i=0;i < this.schedulelist.length;i++) {
                obj=this.schedulelist[i];
                if(!obj.notice_typeid || obj.notice_typeid=='') {result={error:1,message:'第'+(i+1)+'个日程提醒类型不能为空'};return result;}
                if(!obj.create_day || obj.create_day=='') {result={error:1,message:'第'+(i+1)+'个日程提醒创建日程提醒日期不能为空'};return result;}
                if(!obj.create_time || obj.create_time=='') {result={error:1,message:'第'+(i+1)+'个日程提醒创建日程提醒时间不能为空'};return result;}
                if(obj.isremind && (!obj.create_time || obj.create_time=='')) {result={error:1,message:'第'+(i+1)+'个日程提醒的提醒日期不能为空'};return result;}
                if(obj.isremind && (!obj.remind_time || obj.remind_time=='')) {result={error:1,message:'第'+(i+1)+'个日程提醒的提醒时间不能为空'};return result;}
            }
            return result;
        },



        /** 重置加载数据 **/
        resetParam() {
            var data={notice_typeid:'',notice_typename:'',notice_thumb:'',create_day:'',create_time:[],isremind:false,remind_day:'',remind_time:'',note:'',};
            this.schedulelist=[data];
        },


        /////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////
        //关联基础数据加载

        /** 获取提醒信息类型 **/
        GetSheduleTypeInfos() {
            INTERFACE_MODEL_PETS.GET_SCHEDULE_CHILD_TYPE_LIST().then((res) => {
                 if(res.status > 0) return false;
                 this.typelist=res.data;
            });
        },


        /** 获取宠物信息列表 **/
        GetPetList() {
            INTERFACE_MODEL_PETS.GET_PET_LIST().then((res) => {
                 if(res.status > 0) return false;
                 this.petlist=res.data;
            });
        },


         /** 修改宠物信息 **/
        changepet(index,petid) {
            var petname='';
            for(var i in this.petlist) this.petlist[i].id==petid ? petname=this.petlist[i].name : '';
            this.schedulelist[index].petname=petname;
        },



        /** 获取提醒信息 **/
        GetScheduleInfos(ids) {
            INTERFACE_MODEL_PETS.GET_SCHEDULE_INFOS({ids:ids}).then((res) => {
                 if(res.status > 0) return false;
                 this.schedulelist=res.data;
                 for(var i in this.schedulelist) this.schedulelist[i].isremind==1 ? this.schedulelist[i].isremind=true : this.schedulelist[i].isremind=false;
            });
        },


        /** 数据保存到浏览器 **/
        SaveDataToBrowser() {
            var data=JSON.stringify(this.schedulelist);
            localStorage.setItem('editsheduledata',data);
        },

        /** 从浏览器取数据解析 **/
        ParseDataFromBrowser() {
            var data=localStorage.getItem('editsheduledata');
            data ? data : data=[];
            
            !data || data=='' || data==[] ? 
            this.schedulelist=[{notice_typeid:'',notice_typename:'',notice_thumb:'',create_day:'',create_time:[],isremind:false,remind_day:'',remind_time:'',note:'',}] : 
            this.schedulelist=JSON.parse(data);
        },

        /** 返回宠物管理组件 **/
        GoBackPets(isdellocal) {
            var navinfo={name:'日程信息提醒',labelentry:'PetSchedule',components:'PetSchedule',isshow:false};
            var data={Method:''};
            if(isdellocal) data.delcomponents='EditPetSchedule';
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },

        /** 获取type信息图片 **/
        Gettypeinfo(index) {
            var typeid=this.schedulelist[index].notice_typeid;
            this.schedulelist[index].notice_typename='';
            this.schedulelist[index].notice_thumb='';
            for(var i in this.typelist) {
                if(typeid==this.typelist[i].id) {
                    this.schedulelist[index].notice_typename=this.typelist[i].name;
                    this.schedulelist[index].notice_thumb=this.typelist[i].thumb;
                }
            }
            this.SaveDataToBrowser();
        },

    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:120px;height:120px;display: inline-block;border-radius: 5px;}
.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
.petTitle {padding:30px 0 20px 0;}
.TTL-remind-image {display:inline-block;width:70px;height: 70px;margin-left:20px;border-radius: 50%;}
.TTL-remind-image .el-image {border-radius: 50%;}
</style>